module.exports = __webpack_public_path__ + "static/major-works-main-hub-990069037287672300971f0c30a2cba6.png";